import { Component, OnInit, ViewChild } from '@angular/core';
import { Utils } from '../utils/utils';
//import {TipoMotivoComponent} from './tipo-motivo/tipo-motivo.component';
//import {TipoMotivoClasComponent} from './tipo-motivo-clas/tipo-motivo-clas.component';
import {MotivosComponent} from './motivos/motivos.component';

@Component({
  selector: 'app-administracion-motivos',
  templateUrl: './administracion-motivos.component.html',
  styleUrls: ['./administracion-motivos.component.css']
})
export class AdministracionMotivosComponent implements OnInit {

  //@ViewChild(TipoMotivoComponent) child:TipoMotivoComponent;
  //@ViewChild(TipoMotivoClasComponent) childClas:TipoMotivoClasComponent;
  @ViewChild(MotivosComponent, {static: false}) childMotivo:MotivosComponent;
  constructor(
    public ruta: Utils
  ) { 
    
  }

  ngOnInit() {
    this.ruta.setRuta();
  }

  tabClick(tab){
    console.log(tab);
    if(tab.index == 0){
     this.childMotivo.cargarSelect();
    }
    
  }

}
